import { Client } from 'contensis-delivery-api'

let client: Client | null = null // Placeholder for the client

// Custom fetch function to use with the client for search
const customFetch: typeof fetch = async (input, init) => {
  // console.log('Making request to:', input)
  const response = await fetch(input, init)
  // console.log('Received response:', response.status)
  return response
}

// Function to init the client based on versionStatus
export function initClient(
  versionStatus: 'latest' | 'published' = 'published'
) {
  const contensisConfig = {
    rootUrl: 'https://cms-uni-hull.cloud.contensis.com',
    accessToken: 'rRdGBGOsFIIWzFDeXMz9Zf6gpSq8sidf5b2yeys4pqfDbQO7',
    projectId: 'websiteModern',
    versionStatus: versionStatus as VersionStatus // Dynamically set versionStatus
  }

  client = Client.create(contensisConfig) // Init the client
}

// Function to init the client with a custom fetch function for search
export function initClientWithFetch(
  versionStatus: 'latest' | 'published' = 'published',
  fetchFn: typeof fetch = customFetch
) {
  const contensisConfig = {
    rootUrl: 'https://cms-uni-hull.cloud.contensis.com',
    accessToken: 'rRdGBGOsFIIWzFDeXMz9Zf6gpSq8sidf5b2yeys4pqfDbQO7',
    projectId: 'websiteModern',
    versionStatus: versionStatus as VersionStatus,
    fetchFn: fetchFn
  }

  client = Client.create(contensisConfig) // Init the client
}

// Export the client for usage in other files
export function getClient() {
  if (!client) {
    throw new Error('Client not initialised.')
  }
  return client
}
